export default __webpack_public_path__ + "static/media/folder.aec83eef.png";